import { create } from 'zustand';
import { Language } from '@data/sdk/match';

type TranslationType = { [key in Language]: string };

export type QuestionOptionsStore = {
  error: string | null;

  newOption: {
    translations: TranslationType;
  } | null;

  optionToEdit: {
    id: string;
    translations: TranslationType;
  } | null;

  resetStore: () => void;

  setError: (error: string | null) => void;
  setNewOption: (
    optionToEdit: {
      translations: TranslationType;
    } | null,
  ) => void;
  setOptionToEdit: (
    optionToEdit: {
      id: string;
      translations: TranslationType;
    } | null,
  ) => void;
};

export const useQuestionOptionsStore = create<QuestionOptionsStore>((set) => ({
  error: null,
  setError: (error: string | null) => set({ error }),
  optionToEdit: null,
  newOption: null,
  setOptionToEdit: (
    optionToEdit: {
      id: string;
      translations: TranslationType;
    } | null,
  ) => set({ optionToEdit }),
  setNewOption: (
    newOption: {
      translations: TranslationType;
    } | null,
  ) => set({ newOption }),

  resetStore: () => set({ error: null, optionToEdit: null, newOption: null }),
}));
